import { DataTable, Heading, Loader } from "@/components";
import { Button, Input } from "@/components/ui";
import useCategory from "./useProjectCategory";
import { Search } from "lucide-react";

const Category = () => {
  const {
    onAdd,
    isMobile,
    globalFilter,
    setGlobalFilter,
    columns,
    projectCategoryList,
    isLoadingProjectCategory,
  } = useCategory();

  return (
    <div className="p-4 md:p-6">
      {/* Header & Search */}
      <div className="flex flex-col lg:flex-row gap-2 lg:items-center lg:justify-between mb-6">
        <div className="flex flex-row items-center justify-between">
          <Heading title="Project Category" />
          {isMobile && (
            <Button onClick={onAdd} className="px-2">
              + Add Category
            </Button>
          )}
        </div>
        <div className="flex flex-row items-center gap-4">
          <Input
            type="text"
            placeholder="Search"
            value={globalFilter ?? ""}
            onChange={(e) => setGlobalFilter(e.target.value)}
            className="w-full sm:w-72 bg-white h-[40px]"
            startIcon={<Search className="w-4 h-4" />}
          />
          {!isMobile && <Button onClick={onAdd}>+ Add Category</Button>}
        </div>
      </div>

      {/* Responsive Table */}
      {isLoadingProjectCategory ? (
        <Loader />
      ) : (
        <DataTable
          columns={columns}
          data={projectCategoryList?.data || []}
          setGlobalFilter={setGlobalFilter}
          globalFilter={globalFilter}
        />
      )}
    </div>
  );
};

export default Category;
